import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    modalWrapper: {
      '& .mantine-Drawer-drawer': {
        height: 'auto',
        backgroundColor: '#0C0C0C',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderRadius: 0,
        justifyContent: 'space-between',
      },
      '& .mantine-Paper-root': {
        maxHeight: '330px',
      },
    },
    modalTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      // textAlign: 'center',
      justifyContent: 'center',
      gap: '9px',
      marginBottom: '14px',
    },
    modalHeader: {
      fontWeight: 500,
      fontSize: '24px',
      lineHeight: '31px',
      // textAlign: 'center',
      color: '#FFFFFF',
    },
    modalDescription: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      // textAlign: 'center',
      color: '#BFBFBF',
    },
    modalBtnContainer: {
      display: 'flex',
      width: '100%',
      gap: '8px',
    },
    modalBtn: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: '12px 16px',
      gap: '10px',
      color: '#000000',
      borderRadius: '24px',
      fontSize: '14px',
      fontWeight: 500,
      border: 'none',
      background: '#ffffff',
    },
    modalBtnSec: {
      color: '#ffffff',
      background: '#ffffff1A',
    },
    branchDetailsContainer: {
      fontSize: '12px',
      lineHeight: '22px',
      width: '100%',
      '& p': {
        display: 'inline',
        fontWeight: 400,
      },
      '& b': {
        fontWeight: 700,
      },
    },
    bankNameWrapper: {
      display: 'flex',
      alignItems: 'center',
      ...getTypographyStyles('content_sm_semibold'),
      borderBottom: `1px solid ${colors.disabled.muted}`,
      paddingBottom: '16px',
    },
    bankIcon: {
      marginRight: '8px',
    },
    details: {
      marginBottom: '8px',
      width: '100%',
      display: 'flex',
    },
    detailsTitle: {
      width: '25%',
      ...getTypographyStyles('content_sm_regular'),
    },
    detailsValue: {
      width: '75%',
      ...getTypographyStyles('content_sm_semibold'),
    },
  };
});

export default useStyles;
